import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { Card, CardContent } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
// import { Eye, EyeOff } from "lucide-react";
import { Loader } from "./Loader";
import { IsNull, localStoreObjects } from "../utilities/util";
import { Link, useNavigate } from "react-router-dom";
import { PostValidateSignupCoupon } from "./apis/post";


export function Signup() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    gender: "",
    password: "",
    confirmPassword: "",
    coupon_code: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [couponState, setCouponState] = useState({
    checking: false,
    valid: null,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "coupon_code") {
      setCouponState({ checking: false, valid: null, message: "" });
      setErrors((prev) => ({ ...prev, coupon_code: undefined }));
    }
  };
  
  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.username) newErrors.username = "Username is required";
    if (!formData.email || !validateEmail(formData.email)) newErrors.email = "Valid Email is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (!formData.confirmPassword) newErrors.confirmPassword = "Please confirm your password";
    else if (formData.confirmPassword !== formData.password) newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleVerifyCoupon = async () => {
    const couponCode = formData.coupon_code.trim().toUpperCase();
    if (!couponCode) {
      setCouponState({ checking: false, valid: null, message: "" });
      return true;
    }

    setCouponState({ checking: true, valid: null, message: "" });
    const response = await PostValidateSignupCoupon(couponCode);

    if (response?.status === true || response?.valid === true) {
      const normalizedCode = response.coupon_code || couponCode;
      setFormData((prev) => ({ ...prev, coupon_code: normalizedCode }));
      setErrors((prev) => ({ ...prev, coupon_code: undefined }));
      setCouponState({
        checking: false,
        valid: true,
        message: response.message || "Coupon is valid",
      });
      return true;
    }

    setCouponState({
      checking: false,
      valid: false,
      message: response?.detail || response?.message || "Invalid coupon code",
    });
    setErrors((prev) => ({
      ...prev,
      coupon_code: response?.detail || response?.message || "Invalid coupon code",
    }));
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isFormValid = validateForm();
    if (!isFormValid) return;

    const isCouponValid = await handleVerifyCoupon();
    if (!isCouponValid) {
      setErrors((prev) => ({
        ...prev,
        coupon_code: prev.coupon_code || "Please enter a valid coupon code",
      }));
      return;
    }
  };

  if ((errors?.error && typeof errors.error === "string" && errors.error.includes("Please login"))){
    return <div className="flex items-center justify-center min-h-screen bg-gray-900">
    <Card className="w-full max-w-md p-6 bg-gray-800 text-white shadow-lg rounded-2xl mt-10 mb-10 m-5">
      <CardContent>
        <h2 className="text-2xl font-bold text-center mb-4">Please Login</h2>
          <p className="text-red-500 text-center">{errors.error}</p>
        {errors.error && (<div>
          <div className="w-full text-center mt-10 ">

            <Link to="/login" className="w-full text-center bg-green-500 hover:bg-green-900 hover:text-gray-300 mt-10 p-3 rounded-md cursor-pointer">Login Now !</Link>
          </div>
        </div>

        )}
      </CardContent>
    </Card>
  </div>
  }

  if (errors?.error){

    return <div className="flex items-center justify-center min-h-screen bg-gray-900">
    <Card className="w-full max-w-md p-6 bg-gray-800 text-white shadow-lg rounded-2xl mt-10 mb-10 m-5">
      <CardContent>
        <h2 className="text-2xl font-bold text-center mb-4">Please Try Again In Sometime.</h2>
        {errors.error && (<div>
          <p className="text-red-500 text-center">{errors.error}</p>
          <div className="w-full text-center mt-10 ">

            <Link to="/signup" className="w-full text-center bg-green-500 hover:bg-green-900 hover:text-gray-300 mt-10 p-3 rounded-md cursor-pointer" onClick={() =>{setErrors({})}}>Try Again !</Link>
          </div>
        </div>

        )}
      </CardContent>
    </Card>
  </div>
  }


  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      {loading && <Loader />}

      <Card className="w-full max-w-md p-6 bg-gray-800 text-white shadow-lg rounded-2xl mt-10 mb-10 m-5">
        <CardContent>
          <h2 className="text-2xl font-bold text-center mb-4">Signup</h2>

          {submitted ? (<div>
            <p className="text-green-400 text-center">Signup successful!</p>
            <div className="w-full text-center mt-10 ">

              <Link to="/login" className="w-full text-center bg-green-500 hover:bg-green-900 hover:text-gray-300 mt-10 p-3 rounded-md cursor-pointer">Login Now !</Link>
            </div>
          </div>

          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-gray-300" htmlFor="username">Username</Label>
                <Input
                  id="username" name="username" value={formData.username}
                  onChange={handleChange} placeholder="Enter your username"
                  className="pl-3 text-gray-900 placeholder:text-gray-400"
                />
                {errors.username && <p className="text-red-500 text-sm">{errors.username}</p>}
              </div>

              <div>
                <Label className="text-gray-300" htmlFor="email">Email</Label>
                <Input
                  id="email" name="email" value={formData.email}
                  onChange={handleChange} placeholder="Enter your email"
                  className="pl-3 text-gray-900 placeholder:text-gray-400"
                />
                {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
              </div>

              <div>
                <Label className="text-gray-300" htmlFor="gender">Gender</Label>
                <select
                  id="gender" name="gender" value={formData.gender}
                  onChange={handleChange} className="w-full p-2 border border-gray-700 bg-gray-900 text-white rounded-md"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {errors.gender && <p className="text-red-500 text-sm">{errors.gender}</p>}
              </div>

              <div className="relative">
                <Label className="text-gray-300" htmlFor="password">Password</Label>
                <Input
                  id="password" name="password" type={showPassword ? "text" : "password"}
                  value={formData.password} onChange={handleChange} placeholder="Enter your password"
                  className="pl-3 text-gray-900 placeholder:text-gray-400"
                />
                <button type="button" className="absolute right-2 top-9 text-gray-400" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? "🙈" : "👁️"}
                </button>
                {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
              </div>

              <div className="relative">
                <Label className="text-gray-300" htmlFor="confirmPassword">Confirm Password</Label>
                <Input
                  id="confirmPassword" name="confirmPassword" type={showPassword ? "text" : "password"}
                  value={formData.confirmPassword} onChange={handleChange} placeholder="Confirm your password"
                  className="pl-3 text-gray-900 placeholder:text-gray-400"
                />
                {errors.confirmPassword && <p className="text-red-500 text-sm">{errors.confirmPassword}</p>}
              </div>

              <div>
                <Label className="text-gray-300" htmlFor="coupon_code">Coupon Code</Label>
                <div className="flex gap-2">
                  <Input
                    id="coupon_code"
                    name="coupon_code"
                    value={formData.coupon_code}
                    onChange={handleChange}
                    onBlur={handleVerifyCoupon}
                    placeholder="Enter coupon code"
                    className="pl-3 text-gray-900 placeholder:text-gray-400"
                  />
                  <Button
                    type="button"
                    onClick={handleVerifyCoupon}
                    disabled={couponState.checking}
                    className="bg-emerald-500 hover:bg-emerald-600 whitespace-nowrap"
                  >
                    {couponState.checking ? "Checking..." : "Verify"}
                  </Button>
                </div>
                {couponState.message && (
                  <p className={`text-sm mt-1 ${couponState.valid ? "text-green-400" : "text-red-500"}`}>
                    {couponState.message}
                  </p>
                )}
                {errors.coupon_code && <p className="text-red-500 text-sm">{errors.coupon_code}</p>}
              </div>

              <Button type="submit" className="w-full bg-blue-500 hover:bg-blue-600">Signup</Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export function OtpScreen() {
  const [timeLeft, setTimeLeft] = useState(300);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <Card className="w-full max-w-md p-6 bg-gray-800 text-white shadow-lg rounded-2xl mt-0 mb-0 m-5">
        <CardContent>
          <h2 className="text-2xl font-bold text-center mb-4">Enter OTP</h2>
          <p className="text-gray-400 text-center mb-4">Time remaining: {timeLeft} seconds</p>
          <form className="space-y-4">
            <div>
              <Label className="text-gray-300" htmlFor="otp">OTP</Label>
              <Input id="otp" type="text" value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="Enter OTP" required />
            </div>
            <Button type="submit" className="w-full bg-blue-500 hover:bg-blue-600" disabled={timeLeft === 0}>Verify OTP</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
